import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  @Input() title: string = 'Confirm';
  @Input() message: string = 'Are you sure?';
  @Input() confirmText: string = 'Yes';
  @Input() cancelText: string = 'Cancel';

  @Output() closed = new EventEmitter<boolean>(); // optional if parent wants to listen

  visible = false;
  private resolver?: (v: boolean) => void;

  /** Open the dialog and optionally override texts for this call. */
  open(overrides?: Partial<Pick<ConfirmDialogComponent, 'title' | 'message' | 'confirmText' | 'cancelText'>>): Promise<boolean> {
    if (overrides) Object.assign(this, overrides);
    this.visible = true;
    return new Promise<boolean>((resolve) => (this.resolver = resolve));
  }

  /** Close the dialog resolving the awaiting Promise. */
  close(result: boolean) {
    this.visible = false;
    this.resolver?.(result);
    this.resolver = undefined;
    this.closed.emit(result);
  }
}
